import { render } from "./ProductoModal.vue?vue&type=template&id=6401f426&scoped=true"
import script from "./ProductoModal.vue?vue&type=script&lang=js"
export * from "./ProductoModal.vue?vue&type=script&lang=js"

import "./ProductoModal.vue?vue&type=style&index=0&id=6401f426&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6401f426"]])

export default __exports__